module.exports = __webpack_public_path__ + "fonts/GothamNarrow-Bold.a98513eb.ttf";